import {
  useCallback, useEffect, useState,
} from 'react';
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import PeopleIcon from 'Components/common/assets/svgIcons/PeopleIcon';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import NavBarPrimary, { chatActions, chatStates } from 'Components/layout/headers/NavBarPrimary';

import SeeRecommended from 'Components/people/components/SeeRecommended';

import { actions as groupActions } from 'Slice/GroupsSlice';
import { actions as peopleActions } from 'Slice/PeopleSlice';
import { actions as buyerActions } from 'Slice/BuyerGroupsPageSlice';

import { useDispatch, useSelector } from 'react-redux';
import {
  selectAllGroups, selectAllGroupsLoaded, selectBuyerGroupsLoading,
  selectGroupCreateSuccessfully, selectGroupsCount,
  selectIsDuplication, selectAllLoading,
  selectCreatingLoader,
} from 'Selector/GroupsSelector';

import {
  selectRecommendedPeople,
  selectFollowedPeople, selectFollowedPeopleLoading,
  selectPeopleCount,
  selectMorePeopleLoading, selectFilters, selectRecommendedTitle,
  selectRecommendedPeopleLoading, selectRecommendedPeopleLoaded,
} from 'Selector/PeopleSelector';

import PeopleIFollow from 'Components/people/components/PeopleIFollow';
import { FollowedPeopleRequest } from 'Types/RequestBodies';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import styled from 'styled-components';
import {
  maxMobile,
  maxTablet, primaryHeadingColor, secondaryFont, wMedium, maxWidth1300,
} from 'Utils/utilsStyle';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import {
  selectActivetype,
  selectHighlight,
  selectIsHighlighted,
  selectIsScroll, selectScrollToId, selectScrollToPage,
} from 'Selector/CertificationSelector';
import { IsTablet, certificationSmoothBehavior, valueToObject } from 'Utils/UtilityFunctions';
import classNames from 'classnames';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { selectLoaded, selectDisclessPersonality, selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import { actions as UiAction } from 'Slice/UISlice';
import { PEOPLE_ROUTE } from 'Utils/Constants';
import { Gilroy } from 'gilroy-global';
import { useGilroy } from 'Utils/hooks/useGilroy';
import MostActiveGroups from 'Components/people/components/MostActiveGroups';

const Wrapper = styled.div`
  .header-wrapper {
    .left-side-wrap {
      &.smMob-NavBar-Wrapper {
        @media all and (max-width: ${maxMobile}){
          display: flex;
        }
        .bottom-tag {
          @media all and (max-width: ${maxMobile}){
            display: none;
          }
        }
      }
      display: block;
      height: 40px;
      @media all and (max-width: ${maxTablet}){
        width: 100%;
        padding-left: 10px;
      }
      .items-data {
        display: flex;
        align-items: center;
      }
      .bottom-tag {
        font-family: ${secondaryFont};
        color:${primaryHeadingColor};
        font-size: 16px;
        letter-spacing: -0.4px;
        font-weight: ${wMedium};
        margin-top: -20px;
        display: block;
        @media all and (max-width: ${maxWidth1300}){
          font-size: 14px;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          word-wrap: break-word;
        }
      }
    }
  }
`;

const PeoplePage = function PeoplePage() {
  const { gilroyStates, gilroyActions } = useGilroy();
  const { saveUrl: savedUrlV2 } = chatStates;
  const [showSeeRecommended, setShowSeeRecommended] = useState<boolean>(true);
  const [dragging, setDragging] = useState(false);
  const [recommendedCalled, setRecommendedCalled] = useState(true);
  const dispatch = useDispatch();
  const groupsLoading = useSelector(selectBuyerGroupsLoading);
  const allGroupsLoading = useSelector(selectAllLoading);
  const groupsLoaded = useSelector(selectAllGroupsLoaded);
  const created = useSelector(selectGroupCreateSuccessfully);
  const groupsCount = useSelector(selectGroupsCount);
  const groups = useSelector(selectAllGroups);

  const recommendedPeople = useSelector(selectRecommendedPeople);
  const recommendedTitle = useSelector(selectRecommendedTitle);
  const recommendedLoading = useSelector(selectRecommendedPeopleLoading);
  const followedPeople = useSelector(selectFollowedPeople);
  const filters = useSelector(selectFilters);
  const followedLoading = useSelector(selectFollowedPeopleLoading);
  const moreFollowedLoading = useSelector(selectMorePeopleLoading);
  const peopleCount = useSelector(selectPeopleCount);
  const scrollToId: string = useSelector(selectScrollToId);
  const isScroll: boolean = useSelector(selectIsScroll);
  const scrollToPage: string = useSelector(selectScrollToPage);
  const loaded = useSelector(selectRecommendedPeopleLoaded);

  const isDuplication = useSelector(selectIsDuplication);
  const creating = useSelector(selectCreatingLoader);
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const isHighlighted = useSelector(selectIsHighlighted);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const currentUrl = window.location.href;
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const searchTopicLoaded = useSelector(selectLoaded);

  useEffect(() => {
    if (isScroll && scrollToPage.includes(`${PEOPLE_ROUTE}`) && (currentType !== 'person_drag' || loaded)) {
      certificationSmoothBehavior(scrollToId);
      dispatch(certificationActions.setIsScroll(false));
    }
  }, [scrollToId, isScroll, loaded]);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(peopleActions.getFollowedPeople({ offset: 0 }));
    if (!isDuplication && !creating && !created) {
      dispatch(groupActions.getAllGroups({ offset: 0 }));
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('people_page_loaded', 0, {
          offset: 0,
        }),
      ));
    }
    if (savedUrlV2 !== currentUrl) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    } else {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }
    return () => {
      dispatch(groupActions.reset());
      dispatch(buyerActions.setGroupDeleted(false));
    };
  }, []);

  useEffect(() => {
    if (!recommendedPeople.length && !recommendedLoading && recommendedCalled) {
      dispatch(peopleActions.getRecommendedPeople());
      setRecommendedCalled(false);
    }
  }, [recommendedPeople]);

  useEffect(() => {
    if (groupsLoaded) dispatch(groupActions.setIsDuplication(false));
  }, [created, groupsLoaded]);

  useEffect(() => {
    if (!recommendedLoading && !recommendedPeople?.length) setShowSeeRecommended(false);
    else setShowSeeRecommended(true);
  }, [recommendedLoading, recommendedPeople]);

  useEffect(() => {
    if (created && !groupsLoaded) {
      dispatch(groupActions.getAllGroups({ offset: 0 }));
    }
  }, [created]);

  const fetchMorePeople = (obj: FollowedPeopleRequest) => {
    dispatch(peopleActions.getFollowedPeople(obj));
  };
  const applyFilters = (obj: FollowedPeopleRequest) => {
    dispatch(peopleActions.getFollowedPeople(obj));
  };

  const applySearchTerm = (obj: FollowedPeopleRequest) => {
    dispatch(peopleActions.getFollowedPeople(obj));
  }

  const isDrag = useCallback((a: boolean) => {
    if (a) dispatch(groupActions.setDropComplete(false));
    setDragging(a);
  }, [dispatch]);

  useEffect(() => {
    if (!isHighlighted && !isScroll && currentType === 'people_dashboard') {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isScroll, currentType]);

  return (
    <Wrapper>
      <NavBarPrimary>
        <div className="left-side-wrap smMob-NavBar-Wrapper no-overflow-on-header">
          <div className="items-data">
            <PeopleIcon />
            <h1 className="heading">People</h1>
          </div>

          <span className="bottom-tag">Drag and drop a person to create a group</span>
        </div>
        <div className={classNames('right-side-wrap', { highlightedComponent: false })} id="certification-global-search">
          <GlobalSearch
            highlighted
            iconMode={IsTablet()}
          />
          <DrawerAlerts />
          <AccountPopOver />
        </div>
      </NavBarPrimary>
      <div className="container">

        <div
          id="certification-buyer-groups"
          className={classNames(
            { highlightedComponent: isHighlight && currentType === 'people_dashboard' },
            { backgroundColorHighlighted: isHighlight && currentType === 'people_dashboard' },
          )}
        >
          <MostActiveGroups
            loading={!groupsLoaded || groupsLoading || allGroupsLoading}
            loaded={groupsLoaded}
            title="Buyer Groups"
            groupCount={groupsCount}
            groups={groups.slice(0, 4)}
            dragging={dragging}
          />
        </div>

        {showSeeRecommended ? (
          <div id="certification-recommended-people">
            <SeeRecommended
              isDrag={isDrag}
              people={recommendedPeople}
              title={recommendedTitle}
              loading={recommendedLoading}
            />
          </div>
        ) : null}

        <div id="certification-people-follow" className='select-highlight-none'>
          <PeopleIFollow
            isDrag={isDrag}
            peopleCount={peopleCount}
            followedPeople={followedPeople}
            followedLoading={followedLoading}
            fetchMorePeople={fetchMorePeople}
            moreFollowedLoading={moreFollowedLoading}
            filters={filters}
            applyFilters={applyFilters}
            searchPeople={applySearchTerm}
          />
        </div>
      </div>
      {showGlobalGilroy
        ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
        ) : null}
    </Wrapper>
  );
};

export default PeoplePage;
